<template>
  <div
    class="form_states_title"
    :style="'border-left:4px solid' + border + ';' + 'background:'+background"
  >
    <p>{{ title }}</p>
    <div class="tips_box">
      <div class="delete" v-if="delete_form" @click="deleteform">
        <img src="../../assets/19167@2x.png" alt="">
        <p>删除该表</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    background: {
      type: String,
      default: "#EDF8F5"
    },
    border: {
      type: String,
      default: "#1ABF98"
    },
    states: {
      type: Boolean,
      default: true
    },
    delete_form:{
      type:Boolean,
      default:false
    }
  },
  methods:{
    deleteform(){
      this.$emit('deleteform')
    }
  }
};
</script>

<style lang="less" scoped>
.tips_box{
  display: flex;
  align-items: center;
  justify-content: space-between;
  .delete{
    margin-right: 14px;
    cursor: pointer;
    width: 100px;
    height: 31px;
    background: #FFFFFF;
    border: 1px solid #C8CDD5;
    opacity: 1;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    img{
      width: 13px;
      height: 14px;
    }
    p{
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #F9656F;
    }
  }
}
.tips {
  width: 20px;
  height: 20px;
}
.form_states_title {
  width: 858px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 14px;
  box-sizing: border-box;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  line-height: 26px;
  color: #0c0d0f;
}
</style>
